import React from 'react';
import { animateScroll as scroll } from 'react-scroll';

import {  
    Button,
    ArrowTop
} from './ButonStyled';

const scrollToTop = () => {
  // Opções otimizadas
  const options = {
    duration: 300, // ← Reduzido para 300ms (mais rápido)
    smooth: 'easeInOutQuad',
    isDynamic: true,
  };
  
  scroll.scrollToTop(options);
}

const BottomScrollToTop = () => {
  return (
    <Button onClick={scrollToTop}>
      <ArrowTop />
    </Button>
  )
}

export default BottomScrollToTop;